import React from 'react'
import { setAuthStartedCookie } from '@mc/email-capture'
import { Trans } from '@mc/i18n'
import { paths } from '@mc/paths'
import { EMAIL_CAPTURE_I18N } from '../constants'
import { WarningBox } from './WarningBox'

export type EmailWarningVariant = 'already-registered' | 'incomplete-setup'

const I18N_KEYS: Record<EmailWarningVariant, string> = {
  'already-registered': 'email.alreadyExist',
  'incomplete-setup': 'email.incompleteAccountSetup',
}

export const EmailWarning = ({
  variant,
  returnUrl,
  onClick,
}: {
  variant: EmailWarningVariant
  returnUrl?: string
  onClick: (action: string) => void
}) => {
  const handleClick = (evt: React.MouseEvent<HTMLAnchorElement>) => {
    const { textContent } = evt.target as HTMLElement

    if (textContent) {
      setAuthStartedCookie()
      onClick(textContent)
    }
  }

  return (
    <WarningBox>
      <Trans i18nKey={I18N_KEYS[variant]} ns={EMAIL_CAPTURE_I18N}>
        <a
          className='mc-text--link'
          onClick={handleClick}
          href={paths.logIn(returnUrl)}
        />
      </Trans>
    </WarningBox>
  )
}
